export default "__VITE_ASSET__CcOhsk7Y__"